/*
 * Module for the Notes popout in the participant common area quick menu
*/

rs.module("application/sections/participant/commonarea/commonareaquickmenu/notespopout",

    [
        "common/perfect-scrollbar",
        "ui/framework/client-templates",
        "common/select-helper"
    ],

    function (perfectScrollbar, clientTemplates, selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, clientTemplateKeys, constants) {

            var scrollbar = perfectScrollbar.createInstance($.js(jsSelectors.notesContainer), { suppressScrollX: true });

            $("body").prepend(clientTemplates.render(clientTemplateKeys.notePopup, { "notePopupJsSelector": jsSelectors.notePopup }));

            $.js(jsSelectors.addNoteButton).click(function () {

                // reset the form for add
                _resetForm();

                // show the popup
                $.js(jsSelectors.notePopup).modal("show");
                $.js(jsSelectors.notePopup).js(jsSelectors.subject).focus();
            });

            $.js(jsSelectors.saveButton).click(function () {

                var form = $.js(jsSelectors.notePopup).js(jsSelectors.form);

                if (form.valid()) {

                    // save the note
                    $.ajax({
                        type: "POST",
                        url: backendUrls.saveNote,
                        data: {
                            unidocAssocKey: form.js(jsSelectors.unidocAssocKey).val(),
                            unidocKey: form.js(jsSelectors.unidocKey).val(),
                            unidocSubType: form.js(jsSelectors.type).val(),
                            ownerKey: constants.ownerKey,
                            ownerKeyType: constants.ownerType,
                            description: form.js(jsSelectors.subject).val(),
                            unidocText: form.js(jsSelectors.noteText).val(),
                            effectiveDate: form.js(jsSelectors.effectiveDate).val(),
                            terminationDate: form.js(jsSelectors.terminationDate).val(),
                            enteredDate: form.js(jsSelectors.enteredDate).val(),
                            enteredBy: form.js(jsSelectors.enteredBy).val(),
                            enteredByName: form.js(jsSelectors.enteredByName).val(),
                            updateToken: form.js(jsSelectors.updateToken).val()
                        },
                        dataType: "text"

                    })
                        .showFieldErrors()
                        .done(function () {

                            $.js(jsSelectors.notePopup).modal("hide");
                            _reloadNotesList();

                        });
                }
            });

            $.js(jsSelectors.notesContainer).onjs("click", jsSelectors.note, function () {

                $.get(
                    backendUrls.getNote,
                    {
                        unidocAssocKey: $(this).data("unidocassockey")
                    }

                ).done(function (results) {

                    var form = $.js(jsSelectors.notePopup).js(jsSelectors.form);

                    // populate input fields
                    selectHelper.getHelper(form.js(jsSelectors.type)).setValue(results.uniDocSubType?.key);
                    form.js(jsSelectors.subject).val(results.description);
                    form.js(jsSelectors.noteText).val(results.uniDocText);
                    form.js(jsSelectors.terminationDate).val(results.terminationDate ? new Date(results.terminationDate).toISODateString() : null);

                    // populate hidden inputs
                    form.js(jsSelectors.unidocAssocKey).val(results.uniDocAssocKey);
                    form.js(jsSelectors.unidocKey).val(results.uniDocKey);
                    form.js(jsSelectors.effectiveDate).val(results.effectiveDate);
                    form.js(jsSelectors.enteredDate).val(results.enteredDate);
                    form.js(jsSelectors.enteredBy).val(results.enteredBy);
                    form.js(jsSelectors.enteredByName).val(results.enteredByName);
                    form.js(jsSelectors.updateToken).val(results.updateToken);

                    // show the popup 
                    $.js(jsSelectors.notePopup).modal("show");
                    $.js(jsSelectors.notePopup).js(jsSelectors.subject).focus();
                });
            });

            // reload the notes list
            function _reloadNotesList() {

                $.get(backendUrls.getNotesList).done(function (results) {

                    $.js(jsSelectors.notesContainer).html(results);

                    // update scrollbar as notes maybe have been added or removed from the list
                    scrollbar.update();
                });
            }

            // reset form inputs and hidden fields
            function _resetForm() {

                var form = $.js(jsSelectors.notePopup).js(jsSelectors.form);

                // Reset validation
                $.validator.resetValidation(form);

                // reset input fields
                selectHelper.getHelper(form.js(jsSelectors.type).clearErrors()).setValue(constants.defaultNoteType);
                form.js(jsSelectors.subject).val(null).clearErrors();
                form.js(jsSelectors.noteText).val(null).clearErrors();
                form.js(jsSelectors.terminationDate).val(null).clearErrors();

                // reset hidden inputs
                form.js(jsSelectors.unidocAssocKey).val(-1);
                form.js(jsSelectors.unidocKey).val(-1);
                form.js(jsSelectors.effectiveDate).val(null);
                form.js(jsSelectors.enteredDate).val(null);
                form.js(jsSelectors.enteredBy).val(0);
                form.js(jsSelectors.enteredByName).val(null);
                form.js(jsSelectors.updateToken).val(null);
            }
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);